import * as React from 'react'

import { Icon } from '../icon/Icon'
import { SegmentedControlContext } from './SegmentedControlContext'

const sizeMap = {
  sm: 'sm',
  md: 'md',
  lg: 'md'
}

export const SegmentedControlIcon = (
  props: Omit<React.ComponentProps<typeof Icon>, 'size'>
): React.JSX.Element => {
  const { size } = React.useContext(SegmentedControlContext)

  return <Icon {...props} size={sizeMap[size as string]} />
}
